
const onWebsocketOpen = (EventBus: any): any => {
  const events = {
    IS_ALIVE: 'WEBSOCKET_ALIVE',
    IS_CLOSED: 'WEBSOCKET_CLOSED',

    NEW_ASSET_TRANSFER_PROCESSING: 'NEW_ASSET_TRANSFER_PROCESSING',
    NEW_ASSET_TRANSFER_COMPLETED: 'NEW_ASSET_TRANSFER_COMPLETED',
  };

  return {
    events,
    register: (app: any): void => {
      EventBus.$on(events.NEW_ASSET_TRANSFER_PROCESSING, (p: any) => {
        app.$notify({
          title: 'Processing new asset transfer',
          text: `Asset: ${p.ast.substr(0, 15) + '.. [redacted]'}`,
          duration: 50000,
        });
      });

      EventBus.$on(events.NEW_ASSET_TRANSFER_COMPLETED, (p: any) => {
        if (p.err) {
          app.$notify({clean: true});
          app.$notify({
            type: 'error',
            title: 'Asset transfer failed',
            text: `Error: ${p.err}`,
          });
        } else {
          app.$notify({clean: true});
          app.$notify({
            title: 'Asset transfer succeeded!',
            text: `Asset: ${p.ast.substr(0, 15) + '.. [redacted]'}`,
          });
        }
      });
    }
  };
};

export default onWebsocketOpen;
